export default __webpack_public_path__ + "static/media/watch-color.ee056e33.svg";